import { Injectable } from "@angular/core";

import { Observable, Subject } from "rxjs";

/**
 * A successful owner (re)assignment or clear for a single order. Carries both the
 * previous and new owner so consumers can apply an exact delta (e.g. the header's
 * "My orders" count) without a refetch. `null` means unassigned on either side.
 */
export interface OrderOwnerChangeEvent {
  orderId: number;
  previousOwnerId: number | null;
  newOwnerId: number | null;
}

/**
 * App-wide stream of order-ownership changes. The board card's assignment control
 * (the write site) publishes here on a successful write; decoupled consumers such
 * as the global header's "My orders" pill react to keep derived state — like the
 * owned-order count — in sync without polling or a board refetch.
 */
@Injectable({ providedIn: "root" })
export class OrderOwnershipStore {
  private readonly ownerChanges = new Subject<OrderOwnerChangeEvent>();

  /** Emits once per successful ownership change. */
  readonly ownerChanges$: Observable<OrderOwnerChangeEvent> =
    this.ownerChanges.asObservable();

  /** Publishes an ownership change to all subscribers. */
  notifyOwnerChanged(event: OrderOwnerChangeEvent): void {
    this.ownerChanges.next(event);
  }
}
